import { createAction, props } from "@ngrx/store";


export const fetchPaymentMethod = createAction(
  "[Payment Method] Fetch Payment Method",
);

export const fetchPaymentMethodSuccess = createAction(
  "[Payment Method] Fetch Payment Method Success",
  props<{ payment }>()
);

export const fetchPaymentMethodFailure = createAction(
  "[Payment Method] Fetch Payment Method Faild",
  props<{ error }>()
);

export const getPaymentMethod = createAction(
  "[Payment Method] Get Payment Method",
  props<{ id }>()
);

export const getPaymentMethodSuccess = createAction(
  "[Payment Method] Get Payment Method Success",
  props<{ payment }>()
);

export const getPaymentMethodFailure = createAction(
  "[Payment Method] Get Payment Method Failure",
  props<{ error }>()
);

export const updateUserPayout = createAction(
  "[Payment Method] Update User Payment Method",
  props<{ payMethod }>()
);

export const updateUserPayoutSuccess = createAction(
  "[Payment Method] Update User Payment Method Success",
  props<{ payMethod }>()
);

export const updateUserPayoutFailure = createAction(
  "[Payment Method] Update User Payment Method Failure",
  props<{ error }>()
);



